module.exports = __webpack_public_path__ + "img/BYOCS_Icons_SDOH_Healthcare_noBG.2ad54137.png";